import { buildMetricToEventTypeMap } from '@chiroup/core/config/metricDefinitions';

/**
 * Maps ClinicMetricSummary.metricKey → ClinicEvent.eventType so the metric
 * drawer can fetch the underlying raw events.
 *
 * Derived from libs/core metricDefinitions (single source of truth).
 * When metricDefinitions is updated in libs/core, this map is automatically regenerated.
 */
const metricToEventTypeMap = buildMetricToEventTypeMap();

export const metricKeyToEventType = (metricKey: string): string => {
  return metricToEventTypeMap[metricKey] || metricKey;
};
